import React from 'react';
import { FadeIn, CTAButton, Section, Accent, Stars } from './Shared';
import { ProductVideo } from './ProductVideo';
import { featuredTestimonials } from '../data/testimonials';
import { ShieldCheck, Lock, Globe2, Star, X, ArrowRightIcon, FileTextIcon, ZapIcon, LayersIcon, TrophyIcon } from 'lucide-react';
export const HERO_MOCKUP = 'https://cdn.magicpatterns.com/uploads/a5wDcjcYkyBHi6BisQcSi3/MOCKUP_PNG.png';
const PRODUCT_VIDEO = 'https://cdn.magicpatterns.com/uploads/v8gnCg5mXtVLgwG8WBwDon/Libros%20FUNCIONAL.mp4';
export const Hero = () => {
  const chips = [{
    icon: FileTextIcon,
    label: '100% PDF'
  }, {
    icon: ZapIcon,
    label: 'Acceso en 5 min'
  }, {
    icon: LayersIcon,
    label: '365 sesiones'
  }];
  return <section className="relative overflow-hidden border-b border-white/5 bg-slate-950" data-id="element-284" data-mp="dyr7a8hs319l">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-sky-400/40" aria-hidden="true" data-id="element-285" data-mp="1kgmq0cdahgcr" />
      <div className="mx-auto grid w-full max-w-6xl grid-cols-[minmax(0,1fr)] items-center justify-items-center gap-3 px-5 pb-10 pt-4 sm:gap-6 sm:pt-8 md:px-8 md:pb-20 md:pt-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:justify-items-stretch lg:gap-x-12 lg:gap-y-8" data-id="element-286" data-mp="1pe66lixgm57v">
        {/* Headline */}
        <FadeIn className="flex w-full min-w-0 flex-col items-center text-center lg:col-start-1 lg:row-start-1 lg:items-start lg:self-end lg:text-left" data-id="element-287" data-mp="187t19h1gwiuj">
          <p className="mb-2 flex items-center justify-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-sky-400 sm:mb-4 sm:text-xs" data-id="element-288" data-mp="ybpvm17eq22u">
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-sky-400" aria-hidden="true" data-id="element-289" data-mp="tiwsfhrl71sv" />
            MEGAPACK FUNCIONAL 365™
          </p>
          <h1 className="w-full break-words pr-[0.06em] font-display text-[clamp(28px,8.6vw,40px)] font-black uppercase italic leading-[1] tracking-tight text-white sm:text-5xl md:text-6xl lg:pr-0 lg:text-[64px]" data-id="element-290" data-mp="kkumqowwrkz9">
            Organiza todas tus clases de <Accent data-id="element-291" data-mp="anym15d94359">funcional.</Accent>
            <span className="mt-1 block text-slate-400" data-id="element-292" data-mp="xqbu11xqadj">En 5 minutos.</span>
          </h1>
          <p className="mx-auto mt-2.5 max-w-[340px] text-[13.5px] leading-snug text-slate-300 sm:mt-5 sm:max-w-md sm:text-base sm:leading-relaxed md:text-lg lg:mx-0" data-id="element-293" data-mp="5x2xwjkzfdf2">
            Tu sistema completo de entrenamiento funcional: 365 días de sesiones,
            calentamientos, circuitos, progresiones y planificación lista para aplicar.
          </p>
        </FadeIn>

        {/* Mockup */}
        <FadeIn delay={0.05} className="flex w-full min-w-0 justify-center lg:col-start-2 lg:row-span-2 lg:row-start-1" data-id="element-294" data-mp="onucq0nqnw0u">
          <a href="#pricing" className="group block w-full" aria-label="Ver la oferta" data-id="element-295" data-mp="9zhcuslj5t12">
            <img src={HERO_MOCKUP} alt="MEGAPACK Funcional 365 — los 6 tomos, el pack de bonos y el acceso digital en tablet, computadora y celular" width={1536} height={1024} loading="eager" decoding="async"
          // @ts-ignore fetchpriority is valid HTML
          fetchpriority="high" className="mx-auto block h-auto w-full max-w-[380px] object-contain transition-transform duration-200 ease-out group-hover:-translate-y-1 sm:max-w-[560px] lg:max-w-none" data-id="element-296" data-mp="exr8t5f2wxnq" />
          </a>
        </FadeIn>

        {/* CTA */}
        <FadeIn delay={0.1} className="flex w-full min-w-0 max-w-[420px] flex-col items-center sm:max-w-none lg:col-start-1 lg:row-start-2 lg:items-start lg:self-start" data-id="element-297" data-mp="2wws6imajapss">
          <ul className="mb-3 flex w-full flex-wrap items-center justify-center gap-1.5 sm:mb-5 sm:gap-2 lg:justify-start" data-id="element-298" data-mp="247bhlym4hr1b">
            {chips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-white/10 bg-white/5 px-2.5 py-1 text-[11px] font-medium text-slate-200 sm:gap-1.5 sm:px-3 sm:py-1.5 sm:text-xs md:text-sm" data-id="element-299" data-mp="2e4zd4qrjz2kj">
                <Icon size={14} className="text-sky-400" aria-hidden="true" data-id="element-300" data-mp="3pmh8b1v2itvg" />
                {label}
              </li>)}
          </ul>
          <CTAButton href="#pricing" className="w-full sm:w-auto" data-id="element-301" data-mp="srjyvrdnnhp1">
            Quiero el MEGAPACK ahora
            <ArrowRightIcon size={18} className="transition-transform duration-200 group-hover/cta:translate-x-0.5" aria-hidden="true" data-id="element-302" data-mp="xok7oa1w2yju" />
          </CTAButton>
          <div className="mt-3 flex w-full flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center text-[11px] text-slate-400 sm:mt-4 sm:gap-x-4 sm:text-xs lg:justify-start" data-id="element-303" data-mp="17nrgql1lc715">
            <span className="flex items-center gap-1.5" data-id="element-304" data-mp="1bn0bnt8daaya">
              <ShieldCheck size={14} className="text-emerald-400" aria-hidden="true" data-id="element-305" data-mp="1ghea64ibsy76" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-306" data-mp="1leef2c3fvuwp">
              <Lock size={14} aria-hidden="true" data-id="element-307" data-mp="1qf26uzzhsfrz" /> Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-308" data-mp="1vd3xq735tje0">
              <Globe2 size={14} className="text-sky-400" aria-hidden="true" data-id="element-309" data-mp="1vdlrmx2cnlir" /> Pagas en tu moneda local
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  const stats = [{
    value: '+500',
    label: 'coaches confían'
  }, {
    value: '6',
    label: 'Tomos Completos'
  }, {
    value: '5',
    label: 'Bonos incluidos'
  }, {
    value: '4.9/5',
    label: 'calificación',
    star: true
  }];
  return <div className="border-b border-white/5 bg-slate-900/40 px-5 py-8 md:px-8" data-id="element-310" data-mp="2h1cvg030e46">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 gap-y-6 md:grid-cols-4" data-id="element-311" data-mp="3tmt5cm1c02u5">
        {stats.map((s, i) => <div key={s.label} className={`text-center ${i % 2 === 1 ? 'border-l border-white/10' : ''} ${i > 0 ? 'md:border-l md:border-white/10' : ''}`} data-id="element-312" data-mp="3ovkq39dbln92" data-mpi={i}>
            <dt className="sr-only" data-id="element-313" data-mp="l6pvqaqns436">{s.label}</dt>
            <dd className="font-display text-4xl font-black italic leading-none tracking-tight text-white md:text-5xl" data-id="element-314" data-mp="l8kepjiddm4m">
              {s.value}
            </dd>
            <dd className="mt-2 flex items-center justify-center gap-1 text-sm text-slate-400" data-id="element-315" data-mp="2anlgo7720lvf">
              {s.label}
              {s.star && <Star size={12} className="fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-316" data-mp="2fmokjobasm1t" />}
            </dd>
          </div>)}
      </dl>
    </div>;
};
export const Testimonials1 = () => <Section className="bg-slate-950 !py-12 md:!py-16" data-id="element-317" data-mp="25w3ljzrppfid">
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-318" data-mp="1rxvhz9067fy8">
      {featuredTestimonials.map((t, i) => <FadeIn key={t.author} delay={Math.min(i * 0.05, 0.15)} data-id="element-319" data-mp="1vzqk2fpxdxd2" data-mpi={i}>
          <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-5 md:p-6" data-id="element-320" data-mp="1vwvz8n302aj4">
            <Stars data-id="element-321" data-mp="1myj0l3s2j131" />
            <blockquote className="mt-3 text-[15px] leading-relaxed text-slate-200" data-id="element-322" data-mp="1my0w5jv95gk1">
              “{t.text}”
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-323" data-mp="3ce06v5eire1s">
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${t.bg} text-xs font-bold text-white`} data-id="element-324" data-mp="3hbik37zkkffl">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-325" data-mp="10qn9512jvwj2">
                <p className="text-sm font-semibold leading-tight text-white" data-id="element-326" data-mp="10ronbeev4z50">{t.author}</p>
                <p className="text-xs text-slate-500" data-id="element-327" data-mp="1fft4uf26j4m7">{t.role}</p>
              </div>
            </figcaption>
          </figure>
        </FadeIn>)}
    </div>
  </Section>;
export const Problem = () => {
  const painPoints = ['Llegas al gimnasio sin saber exactamente qué clase dar hoy', 'Pierdes horas buscando ejercicios, armando circuitos y pensando como adaptarlas para todo a tu grupo.', 'Terminas repitiendo entrenamientos porque no tienes suficientes sesiones listas para elegir.', 'Quieres un programa anual estructurado pero no tienes tiempo de planificarlo.', 'Buscas trabajar con mayor variedad y progresión, pero sientes que tu grupo se estanca.', 'Fin de semana buscando ideas. El lunes se siente improvisado. Y el ciclo vuelve a empezar.'];
  return <Section className="bg-slate-900/40" data-id="element-328" data-mp="39c71skrduhpg">
      <FadeIn className="mx-auto mb-10 max-w-4xl text-center md:mb-14" data-id="element-329" data-mp="3ec35sk02y950">
        <h2 className="mx-auto font-display text-[30px] font-black uppercase italic leading-[1.08] tracking-tight text-white sm:text-[44px] md:text-[60px] lg:text-[68px]" data-id="element-330" data-mp="3ea8ln7wmul1z">
          Si eres profe de <Accent data-id="element-331" data-mp="3o1d0m7mb65wt">funcional,</Accent>
          <br data-id="element-332" data-mp="2qe47prjz9uks" /> esto te resultará familiar...
        </h2>
      </FadeIn>

      <ul className="mx-auto mb-16 grid max-w-4xl grid-cols-1 gap-x-8 md:mb-24 md:grid-cols-2" data-id="element-333" data-mp="2qfyvreqjq2t3">
        {painPoints.map(point => <li key={point} className="flex items-start gap-3 border-b border-white/5 py-3.5" data-id="element-334" data-mp="30cjwhnvj8rr4">
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-500/15" data-id="element-335" data-mp="34dndwet8avug">
              <X size={12} className="text-red-400" strokeWidth={3} aria-hidden="true" data-id="element-336" data-mp="fmm89sxx0irz" />
            </span>
            <p className="text-[15px] leading-normal text-slate-300 md:text-base" data-id="element-337" data-mp="jmwn7v3oqjiz">{point}</p>
          </li>)}
      </ul>

      <FadeIn className="mx-auto mb-12 max-w-3xl text-center md:mb-16" data-id="element-338" data-mp="24578bt8qqjnb">
        <h3 className="mx-auto pr-[0.06em] font-display text-[clamp(26px,8vw,34px)] font-black uppercase italic leading-[1.08] tracking-tight text-white sm:text-[42px] md:text-[56px] lg:text-[64px]" data-id="element-339" data-mp="203vgri6b3och">
          <span className="block sm:inline" data-id="element-340" data-mp="1qd949wtvzdy0">¿Sigues</span>{' '}
          <span className="block sm:inline" data-id="element-341" data-mp="1lf7njijxnqpp">improvisando</span>{' '}
          <span className="block sm:inline" data-id="element-342" data-mp="1lgiozbpwomdn">tus</span>{' '}
          <span className="block whitespace-nowrap sm:inline" data-id="element-343" data-mp="1gfuz4tdeybl0">
            <Accent data-id="element-344" data-mp="1gih3yl8x6czj">entrenamientos?</Accent>
          </span>
        </h3>
        <div className="mx-auto mt-6 max-w-2xl space-y-4 text-[15px] leading-relaxed text-slate-300 md:mt-8 md:text-lg" data-id="element-345" data-mp="1cesz4abo9vhz">
          <p data-id="element-346" data-mp="17hstu1mncwrx">
            Elegiste esta profesión porque te apasiona el entrenamiento funcional y ver crecer a tu grupo.   
            
           No importa si llevas años como coach o recién estás comenzando.{' '}
            <span className="text-white" data-id="element-347" data-mp="ibej2wwhkmrn">El problema es el mismo.</span>
          </p>
          <p data-id="element-348" data-mp="idhgw33vrk6x">
            Dedicas mas tiempo
            planificando, que entrenando a tu grupo y cuando llega el momento, terminas ajustando cambios
            que se sienten improvisados.
          </p>
          <p data-id="element-349" data-mp="md8fgsznf4m0">Y al día siguiente, vuelves a la misma pregunta:</p>
          <p className="mx-auto inline-block rounded-2xl border border-white/10 bg-white/[0.04] px-5 py-3 font-display text-lg font-extrabold italic leading-snug text-white md:text-2xl" data-id="element-350" data-mp="me1f7a06wtun">
            “¿Qué clase voy a dar mañana?”
          </p>
          <p data-id="element-351" data-mp="8d77ktkyuwx1">
            Y semana tras semana, sigues sacrificando tu tiempo libre para resolver
            el mismo problema.
          </p>
        </div>
      </FadeIn>

      <FadeIn className="mx-auto max-w-3xl" data-id="element-352" data-mp="3knv5zy0m7tt">
        <div className="rounded-3xl border border-sky-400/40 bg-blue-600/10 px-6 py-8 text-center md:px-10 md:py-10" data-id="element-353" data-mp="3c1sb62ere4w6">
          <p className="font-display text-2xl font-black uppercase italic leading-[1.1] tracking-tight text-white md:text-4xl" data-id="element-354" data-mp="372pilhfytr53">
            ¿Y si esta fuera la <Accent data-id="element-355" data-mp="1rc52rauzpolb">última clase</Accent>
            <br data-id="element-356" data-mp="1rd6n65xwbnfp" /> que preparas así?
          </p>
        </div>
      </FadeIn>

      <FadeIn className="mt-20 text-center md:mt-28" data-id="element-357" data-mp="1dl9zce39fzp4">
        <p className="mb-5 inline-flex items-center gap-2 rounded-full bg-amber-400 px-3.5 py-1.5 text-xs font-bold uppercase tracking-wide text-amber-950" data-id="element-358" data-mp="1dinj7q2b0bva">
          <TrophyIcon size={14} aria-hidden="true" data-id="element-359" data-mp="26agzfhid4xch" />
          Sistema n°1 para profesores de Funcional
        </p>
        <h2 className="font-display text-4xl font-black uppercase italic leading-[1.05] tracking-tight text-white md:text-6xl" data-id="element-360" data-mp="2a9puqqt1x3a5">
          MEGAPACK Funcional <Accent data-id="element-361" data-mp="21acftim5rmi1">365™</Accent>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-362" data-mp="2191d7m4g8ksi">
          6 Tomos + 5 Bonos — 365 sesiones listas · Un año completo · Todo resuelto.
        </p>

        <div className="relative mx-auto mt-10 max-w-3xl overflow-hidden rounded-3xl border border-white/10 bg-slate-900 shadow-2xl shadow-black/50" data-id="element-363" data-mp="pw77kdewwqgw">
          <ProductVideo src={PRODUCT_VIDEO} label="Vista previa de los tomos del MEGAPACK Funcional 365" className="block w-full object-cover" data-id="element-364" data-mp="5uw1rpj86haf" />
        </div>
      </FadeIn>
    </Section>;
};